import { CategoriesItemUi } from '@/components/Categories/CategoriesDirectory/Table/CategoriesUi';
import { CategoryResponse } from '@/data/api/model/categories/CategoriesDto';
import {
  BadgeType,
  getGenericBadge,
  StatusBadgeUi,
} from '@/utils/statusBadges';

export const categoryResponseToCategoryItemUi = (
  item: CategoryResponse
): CategoriesItemUi => {
  return {
    categoryId: item.CategoryId,
    categoryName: item.Name,
    categoryParent: item.ParentName,
    categoryProductCount: item.ProductCount,
    status: categoryStatusToStatusBadgeUi(item.Status),
  };
};

export const categoryStatusToStatusBadgeUi = (
  status: string
): StatusBadgeUi | undefined => {
  switch (status) {
    case 'inactive':
      return getGenericBadge(BadgeType.Warning, status, 'Inactivo');
    case 'active':
      return getGenericBadge(BadgeType.Positive, status, 'Activo');
    default:
      return undefined;
  }
};
